/* CSS Modules scopes animation names too, so this stays private to the file
   and `animation-name` below resolves to the hashed name. */
@keyframes skeleton-shimmer {
  from {
    left: -20px;
  }
  to {
    left: 100%;
  }
}

.skeleton {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  overflow: hidden;
  /* Both are required props, so these are always set inline. */
  height: var(--skeleton-height);
  width: var(--skeleton-width);
  background: var(--color-grayscale-arsenic);
  border-radius: 0.4rem;

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    animation-duration: 0.8s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: skeleton-shimmer;
    animation-timing-function: linear;

    background-attachment: fixed;
    background-image: linear-gradient(
      to right,
      var(--color-grayscale-arsenic) 0%,
      var(--color-grayscale-trout) 30%,
      var(--color-grayscale-shuttle) 50%,
      var(--color-grayscale-trout) 80%,
      var(--color-grayscale-arsenic) 100%
    );
  }
}
